/** @format */
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { TimelineControlsService } from '../service/timeline-controls.service';

@Component({
    selector: 'app-show-past-study-terms-checkbox',
    standalone: false,
    templateUrl: './show-past-study-terms-checkbox.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowPastStudyTermsCheckboxComponent {
    private readonly timelineControlsService = inject(TimelineControlsService);

    isChecked$: Observable<boolean> = this.timelineControlsService.showPastStudyTerms$;

    setShowPastStudyTerms(value: boolean) {
        this.timelineControlsService.setShowPastStudyTerms(value);
    }
}
